import React, { useContext, useEffect, useState } from "react";
import ColorsMain from "../../colors/ColorsMain";
import Banner from '../../assets/logos/banner2.png';
import Logo from "../../assets/logos/LogoColurs.png";
import { redirectDocument, useNavigate } from "react-router-dom";

import AcountSuccessful from "../../components/layouts/registro/AcountSuccessful";
import forge from 'node-forge';

import "../../css/login/login.css";
import { GLOBAL_LANGUAGE } from "../../language/language";
import LoginLayout from "../../components/layouts/login/Login";
import SuccessRecovery from "../../components/layouts/login/SuccessRecovery";
import ButtonBack from "../../components/button/ButtonBack"
import ButtonWhite from "../../components/button/ButtonWhite";
import InputLogin from "../../components/inputs/InputLogin";
import OTP from "../../components/layouts/login/Otp";
import RequestPassword from "../../components/layouts/login/RequestPassword";

import { UtilContext } from "../../context/UtilContext";
import { AuthContext } from "../../context/AuthContext";

import axios from "axios";

export const Login = () => {
    const [Layout, setLayout] = useState(1);
    const secretKey = process.env.REACT_APP_HASH;
    const [token, setToken] = useState("");

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [errorUsername, setErrorUsername] = useState(false);
    const [errorPassword, setErrorPassword] = useState(false);

    const navigate = useNavigate();
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);

    const [passwordConfirmation, setPasswordConfirmation] = useState("");
    const [password, setPassword] = useState("");

    const { language } = useContext(UtilContext);
    const { isAuth, setAuthToken, getAuthenticatedHeaders } = useContext(AuthContext);

    useEffect(() => {
        if (isAuth) {
            navigate("/splash");
        }
    }, [isAuth, navigate]);

    const fechTokenRedirect = async () => {
        setLoading(true)
        if (passwordConfirmation !== password) {
            setErrorPassword(true)
            setError('Las contraseñas no coinciden')
            return
        }

        try {
            const response = await axios.post(`/api/new_password`, {
                new_password: password,
                confirmation_password: passwordConfirmation,
                url: token
            });

            if (response.data.status === 200) {
                setLayout(2)
            }
        } catch (error) {
            console.error("Error en new_password:", error.response?.data);
            setErrorPassword(true);
            if (error.response?.data?.data?.message) {
                setError(error.response.data.data.message);
            } else if (error.response?.data?.data?.code_transaction === "PasswordRecoveryLinkExpired") {
                setError("El link para cambiar contraseña se encuentra expirado");
            } else {
                setError("Ha ocurrido un error al cambiar la contraseña");
            }
        } finally {
            setLoading(false);
        }
    }

    function decryptWithAesSimple(transformedToken,) {
        try {
            // Asegurarse de que la clave tenga exactamente 32 bytes (AES-256)
            const key = forge.util.createBuffer(secretKey.slice(0, 32), 'utf8').bytes();
            console.log("Clave (en bytes):", key);

            // Reemplazar los caracteres URL-safe de Base64
            let encryptedToken = transformedToken.replace(/-/g, '+').replace(/_/g, '/');
            console.log("Token después de reemplazar URL-safe:", encryptedToken);

            // Asegurar que la longitud del token sea un múltiplo de 4 para Base64
            while (encryptedToken.length % 4 !== 0) {
                encryptedToken += '='; // Ajuste de longitud para Base64 válido
            }
            console.log("Token con relleno añadido:", encryptedToken);

            // Decodificar el token cifrado desde Base64
            const encryptedBytes = forge.util.decode64(encryptedToken);
            console.log("Bytes descodificados (en binario):", encryptedBytes);

            // Crear un objeto AES en modo ECB
            const decipher = forge.cipher.createDecipher('AES-ECB', key);

            // Iniciar el descifrado
            decipher.start();
            decipher.update(forge.util.createBuffer(encryptedBytes, 'binary'));
            const success = decipher.finish(); // Verificar si la operación fue exitosa

            console.log("Descifrado exitoso:", success);
            if (!success) {
                throw new Error("La operación de descifrado falló.");
            }

            // Obtener el texto descifrado
            const decryptedText = decipher.output.toString('utf8');
            console.log("Texto descifrado:", decryptedText);

            if (!decryptedText) {
                throw new Error('El texto descifrado está vacío.');
            }

            return decryptedText;
        } catch (error) {
            console.error("Error al descifrar el token:", error.message);
            return null;
        }
    }

    const ReturnLogin = () => {

        setLayout(1)
        navigate("/login")
    }

    useEffect(() => {
        setErrorPassword(false)
        setError('')
    }, [password]);


    useEffect(() => {
        // Obtén los parámetros de la URL
        const searchParams = new URLSearchParams(window.location.search);

        const pop = searchParams.get("x_ray");
        const token = decryptWithAesSimple(pop)
        setToken(token)
    }, []);

    return (
        <div className="flex flex-col md:flex-row w-full min-h-screen">
            <div
                className="hidden md:flex md:w-3/5 h-screen relative"
                style={{
                    backgroundImage: `url(${Banner})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <p
                    className="text-white w-[77%] text-[1.5rem] md:text-[2rem] md:leading-[3rem] lg:text-[2.5rem] lg:leading-[4rem] xl:leading-[4.5rem] xl:text-[3.5rem] 2xl:text-[4.5rem] 2xl:leading-[5rem]"
                    style={{
                        fontFamily: "brico",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                    }}
                >
                    {GLOBAL_LANGUAGE[language].banner_login.p1}<br />
                    <span className="text-[#c5c5d3]">
                        {GLOBAL_LANGUAGE[language].banner_login.p2}<br />
                        {GLOBAL_LANGUAGE[language].banner_login.p3}
                    </span>
                </p>
            </div>

            <div
                className="flex w-full md:w-2/5 min-h-screen items-center justify-center flex-col p-4 md:p-0"
                style={{ background: ColorsMain.bgMain }}
            >
                <div className="w-full md:w-3/4 mb-8 md:mb-10 pl-4 md:pl-0">
                    <img src={Logo} className="w-8 h-8" alt="Logo" />
                </div>

                {Layout === 1 && (
                    <div
                        style={{ color: ColorsMain.texttMain }}
                        className="w-full md:w-3/4 flex justify-evenly flex-col px-4 md:px-0"
                    >
                        <div className="flex flex-col">
                            <p className="title">{"Cambiar contraseña"}</p>

                            <p className="text-base font-medium leading-5 tracking-[-0.32px] text-[#B7B7B9] mb-1">
                                {"Nueva contraseña"}
                            </p>
                            <form>
                                <InputLogin
                                    error={errorPassword}
                                    value={passwordConfirmation}
                                    password={true}
                                    onChange={(e) => setPasswordConfirmation(e)}
                                    label={"Nueva contraseña"}
                                    placeholder={"Ingresa tu contraseña"}
                                />
                                <div className="flex flex-row justify-between mb-1 mt-4">
                                    <p className="text-base text-[#B7B7B9] font-medium leading-5 tracking-[-0.32px]">
                                        Confirmar nueva contraseña
                                    </p>
                                </div>

                                <InputLogin
                                    error={errorPassword}
                                    value={password}
                                    LoginRequest={fechTokenRedirect}
                                    onChange={(e) => setPassword(e)}
                                    password={true}
                                    label={"Confirmar nueva contraseña"}
                                    placeholder={"Ingresa tu contraseña"}
                                />
                            </form>
                            <p style={{ color: ColorsMain.errorBorder, marginTop: 8 }}>{error}</p>

                            <div className="flex flex-col md:flex-row justify-between gap-2 md:gap-4 mt-4">
                                <div className="order-2 md:order-1 w-full md:w-auto">
                                    <ButtonBack
                                        onClick={() => navigate('/login')}
                                        label={"Volver"}
                                        className="w-full"
                                    />
                                </div>
                                <div className="order-1 md:order-2 w-full md:w-auto">
                                    <ButtonWhite
                                        onClick={() => fechTokenRedirect()}
                                        label="Guardar contraseña"
                                        loading={loading}
                                        className="w-full"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {Layout === 2 && (
                    <div
                        style={{ color: ColorsMain.texttMain }}
                        className="w-full md:w-3/4 flex justify-evenly flex-col px-4 md:px-0"
                    >
                        <div className="flex flex-col">
                            <p className="text-3xl" style={{ fontFamily: "brico" }}>
                                Cambio de Contraseña Exitoso
                            </p>
                            <p className="text-[#B7B7B9] flex mb-8 mt-2 text-[14px]">
                                Tu contraseña ha sido cambiada correctamente. Por razones de seguridad, debes iniciar sesión nuevamente con tu nueva contraseña para continuar utilizando tu cuenta
                            </p>

                            <div className="w-full md:w-auto">
                                <ButtonBack
                                    onClick={ReturnLogin}
                                    label={"Volver al login"}
                                    className="w-full"
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Login;
